import { isSameUser } from './client/isSameUser';

class UserStore {
  private readonly anonymousUser: Foxkit.UserCookie = {
    accessToken: undefined,
    accountType: undefined,
    device: undefined,
    deviceId: undefined,
    dma: undefined,
    email: undefined,
    firstName: undefined,
    lastName: undefined,
    profileId: undefined,
    refreshToken: undefined,
    tokenExpiration: undefined,
    userType: undefined,
    viewerId: undefined,
  };

  private user: Foxkit.UserCookie;
  private listeners: (() => void)[] = [];

  public constructor() {
    // user is anonymous by default
    this.user = this.anonymousUser;
  }

  public set = (newUser?: Foxkit.UserCookie): void => {
    if (isSameUser(this.user, newUser)) {
      return;
    }

    if (newUser) {
      this.user = newUser;
    } else {
      this.user = this.anonymousUser;
    }

    this.emitChange();
  };

  /**
   * Avoids returning a new object on every call if the underlying value hasn't changed.
   * Since user is derived from the SDK that's regenerated each time, we cache an immutable reference
   * to prevent unnecessary changes when the user object's contents remain the same.
   */
  public get = (): Foxkit.UserCookie => {
    return this.user;
  };

  public subscribe = (listener: () => void): (() => void) => {
    // TODO update this when the SDK implements `onRefreshUpdated`
    this.listeners = [...this.listeners, listener];

    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  };

  private emitChange = (): void => {
    for (const listener of this.listeners) {
      listener();
    }
  };
}

export const userStore = new UserStore();
